

















































































import { getSentinelaTable } from "@/api/farms/index";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import AgroTableDefault from "@/components/agroTableDefault/AgroTableDefault.vue";
import { formattedAreaInHa } from "@/filters/area";
import { stringNotEmpty } from "@/filters/string";
import { BFormGroup, BFormSelect, BPagination } from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { RawLocation, Route } from "vue-router";
import 'vue-select/dist/vue-select.css';

interface CropTypeOption {
  label: string;
  value: string;
};

interface SentinelaFilter {
  search: string;
  cropType: CropTypeOption | null;
  monitoringYear: number | null;
};

@Component({
    name: 'Sentinela',
    components: {
        AgroIcons,
        BFormGroup,
        BFormSelect,
        BPagination,
        AgroTable: AgroTableDefault,
    },
    filters: {
      formattedAreaInHa,
      stringNotEmpty,
    }
})
export default class Sentinela extends Vue {
    private cropTypes = ['SOY', 'CORN', 'SUGARCANE'];
    private filter: SentinelaFilter = {
      search: '',
      cropType: null,
      monitoringYear: null,
    };

    private harvestYears: number[] = [2020, 2021, 2022, 2023];
    private get cropTypesOptions(): CropTypeOption[] {
      return this.cropTypes.map(c =>({
        label: this.$t(`crop-types.${c}`) as string,
        value: c
      }));
    }

    private page: number = 1;
    private size: number = 20;
    private totalRows: number = 20;

    private sortBy: string = '';
    private sortDesc: boolean = true;

    private readonly tableColumns = [
      { name: "actions", sortable: false, label: '' },
      { name: "farmName", sortable: true, sortKey: "farm_name" },
      { name: "ownerName", sortable: true, sortKey: "owner_name" },
      { name: "farmArea", sortable: true, sortKey: "farm_area" },
      { name: "cropArea", sortable: false },
      { name: "harvestPercentage", sortable: false },
      { name: "cropType", sortable: false},
      { name: "monitoringYear", sortable: true, sortKey: "monitoring_year" },
    ];

  private get fields() {
    return this.tableColumns.map(
      v => ({
        label: v.label ?? this.$t(`sentinela.${v.name}`),
        key: v.name,
        sortable: v.sortable,
        sortKey: v.sortKey,
      })
    );
  }

  private async items(ctx: any) {
    const item = await getSentinelaTable(ctx.currentPage - 1, ctx.perPage, ctx.sortBy, ctx.sortDesc, 
                      this.filter.search, this.filter.cropType?.value, this.filter.monitoringYear);

    this.totalRows = item.totalElements;
    return item.data;
  }

  private clearFilter() {
    this.page = 1;
    this.filter.search = '';
    this.filter.cropType = null;
    this.filter.monitoringYear = null;
  }

  private beforeRouteLeave?(
      to: Route,
      from: Route,
      next: (to?: RawLocation | false | ((vm: Vue) => void)) => void): void {
    this.savePage();
    next();
  }

  private created() {
    this.loadPage();
  }

  private savePage() {
    try {
      sessionStorage.setItem('_sentinela-filter', JSON.stringify(this.filter));
      sessionStorage.setItem('_sentinela-page', JSON.stringify(this.page));
      sessionStorage.setItem('_sentinela-size', JSON.stringify(this.size));
      sessionStorage.setItem('_sentinela-totalRows', JSON.stringify(this.totalRows));
      sessionStorage.setItem('_sentinela-sortBy', JSON.stringify(this.sortBy));
      sessionStorage.setItem('_sentinela-sortDesc', JSON.stringify(this.sortDesc));
    } catch(err) {
      console.warn('Could not persist the data into the storage');
    }
  }

  private loadPage() {
    this.totalRows = !!sessionStorage.getItem('_sentinela-totalRows') ? JSON.parse(sessionStorage.getItem('_sentinela-totalRows')!) : this.totalRows;
    this.size = !!sessionStorage.getItem('_sentinela-size') ? JSON.parse(sessionStorage.getItem('_sentinela-size')!) : this.size;
    this.page = !!sessionStorage.getItem('_sentinela-page') ? JSON.parse(sessionStorage.getItem('_sentinela-page')!) : this.page;
    this.sortBy = !!sessionStorage.getItem('_sentinela-sortBy') ? JSON.parse(sessionStorage.getItem('_sentinela-sortBy')!) : this.sortBy;
    this.sortDesc = !!sessionStorage.getItem('_sentinela-sortDesc')? JSON.parse(sessionStorage.getItem('_sentinela-sortDesc')!) : this.sortDesc;
    this.filter = !!sessionStorage.getItem('_sentinela-filter') ? JSON.parse(sessionStorage.getItem('_sentinela-filter')!) : this.filter;
  }

  @Watch('filter', {deep:true})
  private onFilterUpdate(){
    this.$root.$emit('bv::refresh::table', 'SentinelaTable')
  }
}

